import { PRIMARY } from '../../styles';

export default {
  container: {
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: PRIMARY,
    height: '100vh',
    backgroundImage: `url(/images/tile.png)`,
    backgroundRepeat: 'repeat',
  },
  email: {
  },
  password: {
  },
  login: {
    marginTop: 40,
  },
  forgotPass: {

  },
  paper: {
    padding: 30,
    minWidth: 350,
  },
  message: {
    padding: 10,
  }
};



// WEBPACK FOOTER //
// ./src/components/Authentication/Callback/styles.js